var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 13.375L19.4082 13.8831C19.5997 14.2266 19.6955 14.3983 19.6322 14.4719C19.5689 14.5454 19.3603 14.486 18.9433 14.3672C18.5264 14.2484 18.0837 14.1845 17.625 14.1845C15.1397 14.1845 13.125 16.0607 13.125 18.375C13.125 19.1382 13.3441 19.8539 13.727 20.4702M16.125 23.375L15.8417 22.8669C15.6502 22.5234 15.5545 22.3516 15.6178 22.2781C15.6811 22.2045 15.8897 22.264 16.3067 22.3828C16.7236 22.5015 17.1663 22.5655 17.625 22.5655C20.1103 22.5655 22.125 20.6893 22.125 18.375C22.125 17.6117 21.9059 16.8961 21.523 16.2798",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 0.9375V2.8125C11.0625 3.84797 11.9019 4.6875 12.9375 4.6875H16.6875",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6123 23.0625H3.5625C2.52698 23.0625 1.6875 22.223 1.6875 21.1875V2.8125C1.6875 1.77698 2.52698 0.9375 3.5625 0.9375H12.9375C15.0086 0.9375 16.6875 2.61642 16.6875 4.6875V9.98925",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 9.9375H12.9375",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 13.6875H10.125",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 17.4375H9.1875",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibited);
export default __webpack_public_path__ + "static/media/Prohibited.facdb707cb03d8eb89fe3fa310491881.svg";
export { ForwardRef as ReactComponent };